import { load, videoInputDevices } from 'detectrtc';

const loadP = () =>
  new Promise(resolve => {
    load(resolve);
  });

export default () => loadP().then(() => (videoInputDevices || []).length > 0);
